import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import QRCodeGenerate from "../QRCodeGenerate";
import { Container } from "react-bootstrap";
import "./index.css";

export default function PresentQRCode({ }) {

    const searchParams = new URLSearchParams(window.location.search);
    const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

    return (
       
            <Row>
                <Col sm={12} className="mb-3 presentQRCodeBox">
                    <div className="presentQRCodeContainer">
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* <p className="digitalArtText">
                                    This Digital Art entitles you to enter the US Strategy for Ai & Crypto event.
                                </p> */}
                                <p className="presentQRCodeText text-center">
                                Present this QR code at Security Access.
                                </p>
                            </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <img src={imgCDNURL +"QR_Code_Security.webp"} className="qr-code-security-img" />
                                </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        
    );
}
